import { useNavigate } from '@web/Router/router.hooks';
import { useConversationState } from '@web/conversations/Conversation/ConversationProvider/ConversationProvider';
import { useDeleteConversation } from '@web/conversations/hooks/useDeleteConversation';

import { getConversationDeleteTexts } from './conversationDeleteModal.utils';

export const useDeleteConversationModal = () => {
  const navigate = useNavigate();
  const { id } = useConversationState();
  const { mutateAsync } = useDeleteConversation();
  const deleteTexts = getConversationDeleteTexts();

  const onSubmit = async () => {
    await mutateAsync({ id });
    navigate.toConversationRoot();
  };

  return {
    onSubmit,
    deleteTexts,
  };
};
